import { createAsyncThunk, createAction } from '@reduxjs/toolkit';
import CommentAPI from './commentAPI';

// Optimistic add (used before API confirms)
export const addOptimisticComment = createAction(
  'comments/addOptimistic',
  (comment) => ({ payload: comment })
);

// Create a new comment
export const createComment = createAsyncThunk(
  'comments/create',
  async ({ postId, content, parent_comment_id = null, tempId = null }, { rejectWithValue }) => {
    try {
      const newComment = await CommentAPI.create({ postId, content, parent_comment_id });
      return { tempId, newComment };
    } catch (error) {
      return rejectWithValue({
        tempId,
        error: error.response?.data?.detail || error.message,
      });
    }
  }
);

// Update a comment
export const updateComment = createAsyncThunk(
  'comments/update',
  async ({ commentId, updatedCommentData }, { rejectWithValue }) => {
    try {
      return await CommentAPI.update(commentId, updatedCommentData);
    } catch (error) {
      return rejectWithValue(error.response?.data?.detail || error.message);
    }
  }
);

// Delete a comment
export const deleteComment = createAsyncThunk(
  'comments/delete',
  async ({ commentId }, { rejectWithValue }) => {
    try {
      return await CommentAPI.delete(commentId);
    } catch (error) {
      return rejectWithValue(error.response?.data?.detail || error.message);
    }
  }
);

// Like a comment
export const likeComment = createAsyncThunk(
  'comments/like',
  async ({ commentId }, { rejectWithValue }) => {
    try {
      return await CommentAPI.like(commentId);
    } catch (error) {
      if (
        error.response?.status === 400 &&
        error.response?.data?.detail?.includes('already liked')
      ) {
        return rejectWithValue({
          message: 'You have already liked this comment',
          code: 'DUPLICATE_LIKE',
        });
      }
      return rejectWithValue(error.response?.data?.detail || error.message);
    }
  }
);

// Unlike a comment
export const unlikeComment = createAsyncThunk(
  'comments/unlike',
  async ({ commentId }, { rejectWithValue }) => {
    try {
      return await CommentAPI.unlike(commentId);
    } catch (error) {
      if (error.response?.status === 404) {
        return rejectWithValue({
          message: 'You have not liked this comment',
          code: 'NO_LIKE_EXISTS',
        });
      }
      return rejectWithValue(error.response?.data?.detail || error.message);
    }
  }
);
